<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">
      Sobre los costos relacionados específicamente a la atención del caso de depredación
    </h4>
    <p class="text text--gris8 mt-8">Poner únicamente números, si no tuvo gastos colocar un cero</p>

    <form-group :error="errors.has('viaticos') && submitted">
      <input
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.viaticos"
      name="viaticos"
      required
      v-validate="'required'">
      <label class="form__label">Monto total en viáticos (alimentación y hospedaje)</label>
    </form-group>

    <form-group :error="errors.has('combustible') && submitted">
      <input
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.combustible"
      name="combustible"
      required
      v-validate="'required'">
      <label class="form__label">Monto total en combustible</label>
    </form-group>

    <form-group :error="errors.has('horas-funcionario') && submitted">
      <input
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.horasFuncionario"
      name="horas-funcionario"
      required
      v-validate="'required'">
      <label class="form__label">Monto total en horas funcionario</label>
    </form-group>

    <form-group>
      <input
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.otros"
      name="otros-costos"
      >
      <label class="form__label form__label--opcional">
        Otros (por ej. pago de lancha/bote, baterías, etc)
      </label>
    </form-group>

    <form-group class="identado"
    v-if="form.otros"
    :error="errors.has('otros-costos-detalle') && submitted">
      <textarea
      data-vv-validate-on="blur"
      v-if="editando"
      type="text"
      class="form__input"
      v-model="form.otrosDetalle"
      name="otros-costos-detalle"
      required
      v-validate="'required'"/>
      <p v-else class="text">{{form.otrosDetalle}}</p>
      <label class="form__label form__label--required">Detalle el gasto</label>
    </form-group>

    <div class="text--right">
      <h4 class="h4 text--rojo">Monto total de la gira:</h4>
      <h4 class="h4">{{totalGira | colones}}</h4>
    </div>
  </form>
</template>

<script>
export default {
  name: "FormCostos",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
  computed: {
    totalGira() {
      return (this.form.viaticos || 0)
      + (this.form.combustible || 0)
      + (this.form.horasFuncionario || 0)
      + (this.form.otros || 0);
    },
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
